<template>
  <div>
    <vs-chip v-if="size == 'huge'" :color="color" style="font-size: 18px;">
      <span v-if="!$slots.default" :style="'color: ' + textColor">{{ text }}</span>
      <slot v-else></slot>
    </vs-chip>
    <vs-chip v-if="size == 'large'" :color="color" style="font-size: 15px;">
      <span v-if="!$slots.default" :style="'color: ' + textColor">{{ text }}</span>
      <slot v-else></slot>
    </vs-chip>
    <vs-chip v-if="size != 'large' && size != 'huge'" :color="color">
      <span v-if="!$slots.default" :style="'color: ' + textColor">{{ text }}</span>
      <slot v-else></slot>
    </vs-chip>
  </div>
</template>
<script>
export default {
  props: {text: String, color: String, size: String, textColor: String}
};
</script>
<style>
</style>
